import React, { Component } from "react";
import CartContext from "./CartContext";
import { SideMenu } from "./SideMenu";
import { BiRefresh } from "react-icons/bi";
import { BsFillPencilFill } from "react-icons/bs";
import { MessageBox } from "./MessageBox";
import { LoadSpinner } from "./LoadSpinner";
import DatePicker from "react-date-picker";
import { Country, State, City } from "country-state-city";
import axios from "axios";

import {
  OverlayTrigger,
  Tooltip,
  Button,
  ButtonToolbar,
  Form,
  Row,
  Col,
  Modal,
  Nav,
  Table,
  Navbar,
} from "react-bootstrap";

export class Employees extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      employees: [],
      departments: [],
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      reload: true,
    };
  }
  GetEmployees = () => {
    fetch(
      process.env.REACT_APP_API +
        "StoreManager/GetEmployees/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({ employees: data }, () => {
            this.setState({ reload: false }, () => {
              this.setState({ reload: true });
            });
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };
  GetDepartments = () => {
    fetch(
      process.env.REACT_APP_API +
        "StoreManager/GetDepartments/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({ departments: data }, () => {
            this.setState({ reload: false }, () => {
              this.setState({ reload: true });
            });
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  OnSaved = () => {
    this.OnRefreshButtonClick();
  };
  OnDeleted = () => {
    this.OnRefreshButtonClick();
  };

  OnRefreshButtonClick = () => {
    this.setState({ employees: [] }, () => {
      this.GetEmployees();
      this.GetDepartments();
    });
  };
  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };

  OnUpdated = (indexno) => {
    this.OnRefreshButtonClick();
  };

  addModalClose = () => {
    this.setState({ addModalShow: false }, () => {});
    this.OnRefreshButtonClick();
  };

  componentDidMount = () => {
    window.scrollTo(0, 0);
    if (this.state.employees.length == 0) {
      this.GetEmployees();
      this.GetDepartments();
    }
  };

  render() {
    return (
      <>
        <div className="Container-fluid p-0 ">
          <Row>
            {window.innerWidth > 1200 ? (
              <>
                <Col className="m-0 p-0" xs={2}>
                  <SideMenu></SideMenu>
                </Col>
              </>
            ) : (
              <></>
            )}

            <Col
              xs={window.innerWidth > 1200 ? 10 : 12}
              className="pagebackground p-0"
            >
              {this.state.msgboxOpen === true ? (
                <MessageBox
                  open={this.state.msgboxOpen}
                  title={this.state.msgboxTitle}
                  message={this.state.msgboxMessage}
                  callback={this.CloseMessagBoxCallback}
                />
              ) : (
                ""
              )}
              <Navbar className="secondarythemecolor position-sticky fixed-top px-1 m-0 p-1 text-center border-3 border-dark">
                <h4> &nbsp; &nbsp;Employees DB &nbsp;</h4>
                <Navbar.Collapse className="justify-content-end mx-0 ">
                  <Nav>
                    <ButtonToolbar className="text-end align-middle">
                      <Button
                        className="mainthemecolor"
                        // onClick={() => this.handleAddEmployee()}
                        onClick={() => this.setState({ addModalShow: true })}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="26"
                          height="26"
                          fill="currentColor"
                          class="bi bi-plus"
                          viewBox="0 0 16 16"
                        >
                          <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                        </svg>
                        Add
                      </Button>
                      &nbsp;
                      <Button
                        className="mainthemecolor"
                        size=""
                        onClick={() => this.OnRefreshButtonClick()}
                      >
                        <BiRefresh size="26"></BiRefresh>
                        Refresh
                      </Button>
                      &nbsp;
                      {this.state.addModalShow === true ? (
                        <EmployeeAddOrEditModal
                          show={this.state.addModalShow}
                          employees={this.state.employees}
                          departments={this.state.departments}
                          Type="Add"
                          onHide={this.addModalClose}
                        />
                      ) : null}
                    </ButtonToolbar>
                  </Nav>
                </Navbar.Collapse>
              </Navbar>
              <div>
                <Table border striped className="px-0 bg-white ">
                  <thead className="">
                    <tr className="text-start text-black bg-white border">
                      {/* <th>#</th> */}
                      <>
                        <th width="10%">EmpNo</th>
                        <th width="10%">Name</th>
                        <th width="10%">Manager</th>
                        <th width="10%">Department</th>
                        <th width="10%">Title</th>
                        <th width="10%">Phoneno</th>
                        <th width="10%">JoinDate</th>
                        <th width="10%">Status</th>
                        <th width="10%">Monthly Salary</th>
                        <th width="10%" className="text-end">
                          Options
                        </th>
                      </>
                    </tr>
                  </thead>
                  <tbody className="text-primary border">
                    {this.state.employees
                      .sort((a, b) => (a.empNo > b.empNo ? 1 : -1))
                      .map((employee, i) =>
                        this.state.reload === true ? (
                          <EditEmployeeInline
                            index={i}
                            employee={employee}
                            employees={this.state.employees}
                            departments={this.state.departments}
                            OnDeleted={this.OnDeleted}
                          ></EditEmployeeInline>
                        ) : null
                      )}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

export class EditEmployeeInline extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      employee: "",
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      editModalShow: false,
    };
  }

  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };
  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };
  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  OnDelete = () => {
    if (this.state.employee.id == undefined) {
      this.ShowMessagBox(
        "Information",
        "This is invalid row which can't be deleted. Press Refresh!"
      );
      return;
    }

    this.ShowLoadSpinner();
    const requestOptions = {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    };

    fetch(
      process.env.REACT_APP_API +
        "StoreManager/DeleteEmployee/" +
        this.state.employee.id,
      requestOptions
    )
      .then((res) => {
        if (res.status != 200) {
          this.HideLoadSpinner();
          alert(
            "Not deleted. This Employee may be associated with few Products. First disassociate this employee from the Products and then try!"
          );
          return;
        }
        this.HideLoadSpinner();
        this.ShowMessagBox(
          "Status",
          "Deleted Successfully. Click Refresh Button to see the changes!"
        );
        this.props.OnDeleted();
      })
      .catch((error) => {
        this.HideLoadSpinner();
        alert("OnDelete Failed" + error);
      });
  };

  componentDidMount = () => {
    this.setState({ employee: this.props.employee });
  };
  OnEditButtonClick = () => {
    this.setState({ editModalShow: true }, () => {});
  };

  editModalClose = () => {
    this.setState({ editModalShow: false }, () => {});
  };

  getManagerName = (mgrId) => {
    var r = this.props.employees.filter((f) => f.id == mgrId);
    if (r.length > 0) {
      return (
        r[0].firstName + " " + r[0].lastName + " [Empno=" + r[0].empNo + "]"
      );
    }
    return "";
  };
  getDepartName = (id) => {
    var r = this.props.departments.filter((f) => f.id == id);
    if (r.length > 0) {
      return r[0].name;
    }
    return "";
  };

  render() {
    return (
      <>
        {this.state.editModalShow === true ? (
          <EmployeeAddOrEditModal
            show={this.state.editModalShow}
            onHide={this.editModalClose}
            employee={this.state.employee}
            employees={this.props.employees}
            departments={this.props.departments}
            Type="Edit"
          />
        ) : (
          ""
        )}
        {this.state.loadSpinnerOpen === true ? (
          <LoadSpinner open="true"></LoadSpinner>
        ) : (
          ""
        )}
        <tr
          className="text-center align-middle text-secondary bg-white mx-5"
          style={{ fontSize: "12px" }}
        >
          {this.state.msgboxOpen === true ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : (
            ""
          )}
          {/* <td className="text-start ">{this.props.index + 1}</td> */}
          <td className="text-start ">{this.state.employee.empNo}</td>
          <td className="text-start ">
            {this.state.employee.firstName +
              " " +
              this.state.employee.lastName +
              " [EmpNo=" +
              this.state.employee.empNo +
              "]"}
          </td>
          <td className="text-start ">
            {this.getManagerName(this.state.employee.mgrId)}
          </td>
          <td className="text-start ">
            {this.getDepartName(this.state.employee.departmentId)}
          </td>
          <td className="text-start ">{this.state.employee.jobTitle}</td>
          <td className="text-start ">{this.state.employee.phoneNo}</td>
          <td className="text-start ">
            {this.context.GetInDateFormat(
              new Date(this.state.employee.joinDate)
            )}
          </td>
          <td className="text-start ">
            {this.state.employee.status == 1
              ? "Active"
              : this.state.employee.status == 2
              ? "UnpaidLeave"
              : this.state.employee.status == 3
              ? "Exited"
              : ""}
          </td>
          <td className="text-start ">
            {Number(this.state.employee.basicSalary) +
              Number(this.state.employee.bonus) +
              Number(this.state.employee.hra) +
              Number(this.state.employee.conveyanceAllowance) +
              Number(this.state.employee.medicalAllowance)}
          </td>
          <td className="col-md-2 text-end align-middle ">
            <div class="btn-group">
              <OverlayTrigger overlay={<Tooltip>Edit!</Tooltip>}>
                <Button
                  className="mainthemecolor"
                  onClick={(e) => {
                    this.OnEditButtonClick(e);
                  }}
                >
                  <BsFillPencilFill size="20" />
                </Button>
              </OverlayTrigger>

              <OverlayTrigger
                overlay={
                  <Tooltip>
                    Warning! This will delete this Brand Row and associated
                    Products as well.
                  </Tooltip>
                }
              >
                <Button
                  className="mx-1 mainthemecolor"
                  onClick={(e) => {
                    if (
                      window.confirm(
                        "Warning! This action will delete this Brand Row and associated Products as well. Are you sure you want to Delete?"
                      )
                    ) {
                      this.OnDelete(e);
                    }
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="currentColor"
                    class="bi bi-trash"
                    viewBox="0 0 16 16"
                  >
                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                    <path
                      fill-rule="evenodd"
                      d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                    />
                  </svg>
                </Button>
              </OverlayTrigger>
            </div>
          </td>
        </tr>
      </>
    );
  }
}

export class EmployeeAddOrEditModal extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);

    this.state = {
      employee: {
        firstName: "",
        lastName: "",
        mgrId: null,
        basicSalary: 0,
        bonus: 0,
        da: 0,
        hra: 0,
        dob: new Date(),
        joinDate: new Date(),
        conveyanceAllowance: 0,
        medicalAllowance: 0,
        pfContribution: 0,
      },
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,
    };
  }

  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
    this.props.onHide();
  };
  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };
  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };

  AddOrUpdateEmployeeInDB = () => {
    this.ShowLoadSpinner();

    var tmpEmployee = this.state.employee;
    if (this.props.Type == "Edit") {
      tmpEmployee = this.props.employee;
    } else {
      tmpEmployee.storeId = this.context.storeId;
    }
    if (tmpEmployee.dob) {
      tmpEmployee.dob =
        new Date(tmpEmployee.dob).getMonth() +
        1 +
        "/" +
        new Date(tmpEmployee.dob).getDate() +
        "/" +
        new Date(tmpEmployee.dob).getFullYear();
    }
    if (tmpEmployee.joinDate) {
      tmpEmployee.joinDate =
        new Date(tmpEmployee.joinDate).getMonth() +
        1 +
        "/" +
        new Date(tmpEmployee.joinDate).getDate() +
        "/" +
        new Date(tmpEmployee.joinDate).getFullYear();
    }
    if (tmpEmployee.exitDate) {
      tmpEmployee.exitDate =
        new Date(tmpEmployee.exitDate).getMonth() +
        1 +
        "/" +
        new Date(tmpEmployee.exitDate).getDate() +
        "/" +
        new Date(tmpEmployee.exitDate).getFullYear();
    }

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(tmpEmployee),
    };

    // fetch(
    //   process.env.REACT_APP_API + "StoreManager/AddOrUpdateEmployee/",
    //   requestOptions
    // )
    axios
      .post(
        process.env.REACT_APP_API + "StoreManager/AddOrUpdateEmployee/",
        tmpEmployee
      )
      .then((res) => {
        if (res.status == 200) {
          this.HideLoadSpinner();
          this.props.onHide();
          return;
        }
        this.HideLoadSpinner();
        alert("This Employee is already exist. try again!");
        return;
      })
      .catch((error) => {
        this.HideLoadSpinner();
        alert("Exception. Received an Exception. Try after sometime !" + error);
      });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.AddOrUpdateEmployeeInDB();
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;

    switch (name.trim()) {
      case "firstName":
        this.state.employee.firstName = value;
        break;
      case "lastName":
        this.state.employee.lastName = value;
        break;
      case "mgrId":
        this.state.employee.mgrId = value;
        break;
      case "departmentId":
        this.state.employee.departmentId = value;
        break;
      case "jobTitle":
        this.state.employee.jobTitle = value;
        break;
      case "phoneNo":
        this.state.employee.phoneNo = value;
        break;
      case "emailId":
        this.state.employee.emailId = value;
        break;
      case "dob":
        this.state.employee.dob = value;
        break;
      case "gender":
        this.state.employee.gender = value;
        break;
      case "address":
        this.state.employee.address = value;
        break;
      case "city":
        this.state.employee.city = value;
        break;
      case "state":
        this.state.employee.state = value;
        break;
      case "country":
        this.state.employee.country = value;
        break;
      case "status":
        this.state.employee.status = value;
        break;
      case "exitReason":
        this.state.employee.exitReason = value;
        break;
      case "basicSalary":
        this.state.employee.basicSalary = value;
        break;
      case "bonus":
        this.state.employee.bonus = value;
        break;
      case "da":
        this.state.employee.da = value;
        break;
      case "hra":
        this.state.employee.hra = value;
        break;
      case "conveyanceAllowance":
        this.state.employee.conveyanceAllowance = value;
        break;
      case "medicalAllowance":
        this.state.employee.medicalAllowance = value;
        break;
      case "pfcontribution":
        this.state.employee.pfcontribution = value;
        break;
      case "bankAccNo":
        this.state.employee.bankAccNo = value;
        break;
      case "bankName":
        this.state.employee.bankName = value;
        break;
      case "ifscCode":
        this.state.employee.ifscCode = value;
        break;
      case "upiId":
        this.state.employee.upiId = value;
        break;
      case "panNumber":
        this.state.employee.panNumber = value;
        break;
      case "pfNumber":
        this.state.employee.pfNumber = value;
        break;
      case "esiNumber":
        this.state.employee.esiNumber = value;
        break;
      case "description":
        this.state.employee.description = value;
        break;
    }

    this.setState({ employee: this.state.employee });
  };

  HireDateChange = (date) => {
    var t = this.state.employee;
    t.joinDate = date;
    this.setState({ employee: t }, () => {});
  };

  ExitDateChange = (date) => {
    var t = this.state.employee;
    t.exitDate = date;
    this.setState({ employee: t }, () => {});
  };

  componentDidMount() {
    if (this.props.Type == "Edit") {
      this.setState({ employee: this.props.employee });
    }
  }

  render() {
    return (
      <div className="container ">
        <Modal
          {...this.props}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
          keyboard={false}
          dialogClassName="EmployeeModal"
        >
          {this.state.msgboxOpen === true ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : (
            ""
          )}
          {this.state.loadSpinnerOpen === true ? (
            <LoadSpinner open="true"></LoadSpinner>
          ) : (
            ""
          )}
          <Form onSubmit={this.handleSubmit}>
            <Modal.Header closeButton className="bg-warning">
              <Modal.Title id="contained-modal-title-vcenter">
                {this.props.Type == "Edit" ? "Edit employee" : "Add employee"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="show-grid ">
              <Row
                className="m-2 p-2 bg-light border"
                style={{ fontSize: "9pt" }}
              >
                <Col md={4}>
                  <div className="border p-2">
                    <h3>Personal Details</h3>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        First Name
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          type="text"
                          name="firstName"
                          maxlength="19"
                          value={this.state.employee.firstName}
                          required
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        Last Name
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          type="text"
                          name="lastName"
                          maxlength="19"
                          value={this.state.employee.lastName}
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        Gender
                      </Form.Label>
                      <Col sm="9">
                        <Form.Select
                          type="text"
                          name="gender"
                          value={this.state.employee.gender}
                          placeholder=""
                          required
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        >
                          <option value=""></option>
                          <option value={true}>Male</option>
                          <option value={false}>Female</option>
                        </Form.Select>
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        Contact No
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          type="number"
                          name="phoneNo"
                          value={this.state.employee.phoneNo}
                          required
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        Email-id
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          type="email"
                          name="emailId"
                          value={this.state.employee.emailId}
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        DOB
                      </Form.Label>
                      <Col sm="9">
                        <DatePicker
                          format="dd-MMM-yy"
                          onChange={(e) => {
                            var t = this.state.employee;
                            t.dob = e;
                            this.setState({ employee: t }, () => {});
                          }}
                          required
                          value={this.state.employee.dob}
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        Address
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          type="text"
                          name="address"
                          maxlength="49"
                          value={this.state.employee.address}
                          required
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        Country
                      </Form.Label>
                      <Col sm="9">
                        <Form.Select
                          type="text"
                          name="country"
                          value={this.state.employee.country}
                          required
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        >
                          <option value=""></option>
                          {Country.getAllCountries().map((country) => (
                            <>
                              <option value={country.isoCode}>
                                {country.name}
                              </option>
                            </>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        State
                      </Form.Label>
                      <Col sm="9">
                        <Form.Select
                          type="text"
                          name="state"
                          value={this.state.employee.state}
                          required
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        >
                          <option value=""></option>
                          {State.getStatesOfCountry(
                            this.state.employee.country
                          ).map((s1) => (
                            <>
                              <option>{s1.name}</option>
                            </>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        City
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          type="text"
                          name="city"
                          value={this.state.employee.city}
                          required
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        />
                      </Col>
                    </Form.Group>
                  </div>
                  <div className="border p-2">
                    <h3>Official Details</h3>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        EmpNo
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          type="text"
                          name="empNo"
                          value={this.state.employee.empNo}
                          disabled
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        Manager
                      </Form.Label>
                      <Col sm="9">
                        <Form.Select
                          type="text"
                          name="mgrId"
                          value={this.state.employee.mgrId}
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        >
                          <option value=""></option>
                          {this.props.employees
                            .filter((f) => f.id != this.state.employee.id)
                            .map((e) => (
                              <>
                                <option value={e.id}>
                                  {e.firstName +
                                    " " +
                                    e.lastName +
                                    "(empno=" +
                                    e.empNo +
                                    ")"}
                                </option>
                              </>
                            ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        Department
                      </Form.Label>
                      <Col sm="9">
                        <Form.Select
                          type="text"
                          name="departmentId"
                          value={this.state.employee.departmentId}
                          placeholder=""
                          required
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        >
                          <option value=""></option>
                          {this.props.departments.map((e) => (
                            <>
                              <option value={e.id}>{e.name}</option>
                            </>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        Job Title
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          type="text"
                          name="jobTitle"
                          maxlength="49"
                          value={this.state.employee.jobTitle}
                          required
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        />
                      </Col>
                    </Form.Group>
                  </div>
                </Col>
                <Col md={4}>
                  <div className="border p-2">
                    <h3>Employee Status</h3>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        Hire Date
                      </Form.Label>
                      <Col sm="9">
                        <DatePicker
                          format="dd-MMM-yy"
                          onChange={(e) => this.HireDateChange(e)}
                          required
                          value={this.state.employee.joinDate}
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        Status
                      </Form.Label>
                      <Col sm="9">
                        <Form.Select
                          type="text"
                          name="status"
                          value={this.state.employee.status}
                          placeholder=""
                          required
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        >
                          <option value=""></option>
                          <option value="1">Active</option>
                          <option value="2">UnpaidLeave</option>
                          <option value="3">Exited</option>
                        </Form.Select>
                      </Col>
                    </Form.Group>
                    <div>
                      <Form.Group as={Row} className="mb-3 " controlId="">
                        <Form.Label column sm="3">
                          Exit Date
                        </Form.Label>
                        <Col sm="9">
                          <DatePicker
                            format="dd-MMM-yy"
                            disabled={this.state.employee.status != 3}
                            onChange={(e) => this.ExitDateChange(e)}
                            value={this.state.employee.exitDate}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} className="mb-3 " controlId="">
                        <Form.Label column sm="3">
                          Exit Reason
                        </Form.Label>
                        <Col sm="9">
                          <Form.Control
                            type="text"
                            name="exitReason"
                            maxlength="254"
                            value={this.state.employee.exitReason}
                            disabled={this.state.employee.status != 3}
                            placeholder=""
                            autoComplete="off"
                            onChange={(e) => this.handleInputChange(e)}
                          />
                        </Col>
                      </Form.Group>
                    </div>
                  </div>
                  <div className="border p-2">
                    <h3>Monthly Salary Package</h3>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        Basic Salary
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          type="number"
                          name="basicSalary"
                          required
                          value={this.state.employee.basicSalary}
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        Bonus
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          type="number"
                          name="bonus"
                          required
                          value={this.state.employee.bonus}
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        DA
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          type="number"
                          name="da"
                          required
                          value={this.state.employee.da}
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        HRA
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          type="number"
                          name="hra"
                          required
                          value={this.state.employee.hra}
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        Conveyance Allowance
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          type="number"
                          name="conveyanceAllowance"
                          value={this.state.employee.conveyanceAllowance}
                          placeholder=""
                          required
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        Medical Allowance
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          type="number"
                          name="medicalAllowance"
                          required
                          value={this.state.employee.medicalAllowance}
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        PF Contribution
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          type="number"
                          name="pfContribution"
                          required
                          value={this.state.employee.pfContribution}
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        />
                      </Col>
                    </Form.Group>
                  </div>
                </Col>
                <Col md={4}>
                  <div>
                    <h4>Bank Details</h4>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        Bank AccNo
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          type="text"
                          name="bankAccNo"
                          required
                          value={this.state.employee.bankAccNo}
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        Bank Name
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          type="text"
                          name="bankName"
                          required
                          value={this.state.employee.bankName}
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        IFSC Code
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          type="text"
                          name="ifscCode"
                          required
                          value={this.state.employee.ifscCode}
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        UPI Number / ID
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          type="text"
                          name="upiId"
                          required
                          value={this.state.employee.upiId}
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        PAN Number
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          type="text"
                          name="panNumber"
                          required
                          value={this.state.employee.panNumber}
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        PF Number
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          type="text"
                          name="pfNumber"
                          required
                          value={this.state.employee.pfNumber}
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3 " controlId="">
                      <Form.Label column sm="3">
                        ESI Number
                      </Form.Label>
                      <Col sm="9">
                        <Form.Control
                          type="text"
                          name="esiNumber"
                          required
                          value={this.state.employee.esiNumber}
                          placeholder=""
                          autoComplete="off"
                          onChange={(e) => this.handleInputChange(e)}
                        />
                      </Col>
                    </Form.Group>
                  </div>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Col sm="12">
                      Description:
                      <Form.Control
                        as="textarea"
                        type="text"
                        rows={10}
                        maxLength={1999}
                        name="description"
                        value={this.state.employee.description}
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer className="bg-light">
              <Form.Group>
                <Button variant="primary" size="lg" type="submit">
                  Save
                </Button>
              </Form.Group>

              <Button variant="danger" size="lg" onClick={this.props.onHide}>
                Close
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    );
  }
}
